"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _errorLoading = _interopRequireDefault(require("../../../assets/images/error-loading.png"));

var _Skeleton = _interopRequireDefault(require("../../Skeleton/Skeleton"));

var _EmptyTable = _interopRequireDefault(require("../EmptyTable/EmptyTable"));

var _StatusHint = require("./StatusHint.styles");

var _util = require("../../../util");

// The table is using border-spacing to seperate the items and that
// doesnt translate super well to margins that the skeleton items
// are using.
var SkeletonContainer = (0, _base["default"])("div", {
  target: "esg3oyo0",
  label: "SkeletonContainer"
})(_StatusHint.styles.skeletonContainer, ";padding-top:", function (_ref) {
  var separate = _ref.separate;
  return separate ? (0, _util.rem)(7) : (0, _util.rem)(8);
}, ";padding-bottom:", function (_ref2) {
  var separate = _ref2.separate;
  return separate ? (0, _util.rem)(1) : (0, _util.rem)(8);
}, ";");

var StatusHint = function StatusHint(_ref3) {
  var hasPage = _ref3.hasPage,
      hasFooter = _ref3.hasFooter,
      hasHeader = _ref3.hasHeader,
      hasError = _ref3.hasError,
      separate = _ref3.separate,
      loading = _ref3.loading,
      onRefresh = _ref3.onRefresh,
      emptyContent = _ref3.emptyContent,
      noFound = _ref3.noFound,
      errorTitle = _ref3.errorTitle,
      errorSubtitle = _ref3.errorSubtitle,
      errorImg = _ref3.errorImg,
      noSearchResultTitle = _ref3.noSearchResultTitle,
      noSearchResultSubtitle = _ref3.noSearchResultSubtitle,
      noSearchResultImg = _ref3.noSearchResultImg,
      pageSize = _ref3.pageSize;
  if (hasPage) return null;
  var hasContainer = hasHeader || hasFooter; // Loading

  if (loading) {
    return (0, _jsxRuntime.jsx)(SkeletonContainer, {
      hasContainer: hasContainer,
      hasFooter: hasFooter,
      separate: separate,
      children: (0, _jsxRuntime.jsx)(_Skeleton["default"], {
        className: "grui mb-5" // pageSize is default to 1, so the default prop of pageSize 4 is not working
        // need to set skeleton to be 4 at least for tables that don't have pagination
        ,
        count: pageSize > 4 ? pageSize : 4,
        height: separate ? 48 : 32
      })
    });
  } // Has loading error


  if (hasError) {
    return (0, _jsxRuntime.jsx)(_EmptyTable["default"], {
      forError: true,
      onRefresh: onRefresh,
      hasContainer: hasContainer,
      hasFooter: hasFooter,
      title: errorTitle,
      subtitle: errorSubtitle,
      img: errorImg
    });
  } // No search result


  if (noFound) {
    return (0, _jsxRuntime.jsx)(_EmptyTable["default"], {
      hasContainer: hasContainer,
      hasFooter: hasFooter,
      title: noSearchResultTitle,
      subtitle: noSearchResultSubtitle,
      img: noSearchResultImg
    });
  }

  return emptyContent || null;
};

StatusHint.propTypes = {
  hasPage: _propTypes.bool,
  hasFooter: _propTypes.bool,
  hasHeader: _propTypes.bool,
  hasError: _propTypes.bool,
  separate: _propTypes.bool,
  loading: _propTypes.bool,
  noFound: _propTypes.bool,
  onRefresh: _propTypes.func,
  emptyContent: _propTypes.node,
  errorTitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  errorSubtitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  errorImg: _propTypes.string,
  noSearchResultTitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  noSearchResultSubtitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  noSearchResultImg: _propTypes.string,
  pageSize: _propTypes.number
};
StatusHint.defaultProps = {
  hasPage: false,
  hasFooter: false,
  hasHeader: false,
  hasError: false,
  separate: false,
  loading: false,
  noFound: false,
  onRefresh: function onRefresh() {},
  emptyContent: undefined,
  errorTitle: 'Error loading data',
  errorSubtitle: 'Oh no! There was an error problem loading the data…',
  errorImg: _errorLoading["default"],
  noSearchResultTitle: undefined,
  noSearchResultSubtitle: undefined,
  noSearchResultImg: undefined,
  pageSize: 4
};
var _default = StatusHint;
exports["default"] = _default;
//# sourceMappingURL=StatusHint.js.map